var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-svg-lvl-3":"cover-back-contour","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 514 430"}},[_c('defs'),_c('g',{attrs:{"id":"Задник_Контур"}},[_c('path',{staticClass:"bc-c-3",attrs:{"d":"M389.26,114.94H119.82V322.86H389.26a9.13,9.13,0,0,0,9.13-9.13V124.07A9.13,9.13,0,0,0,389.26,114.94Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }